import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './bursa-api-bid-cert.reducer';
import { IBursaAPIBidCert } from 'app/shared/model/bursa-api-bid-cert.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIBidCertUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const bursaAPIBidCertEntity = useAppSelector(state => state.bursaAPIBidCert.entity);
  const loading = useAppSelector(state => state.bursaAPIBidCert.loading);
  const updating = useAppSelector(state => state.bursaAPIBidCert.updating);
  const updateSuccess = useAppSelector(state => state.bursaAPIBidCert.updateSuccess);
  const handleClose = () => {
    props.history.push('/bursa-api-bid-cert' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...bursaAPIBidCertEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bursaAPIBidCertEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="comexApp.bursaAPIBidCert.home.createOrEditLabel" data-cy="BursaAPIBidCertCreateUpdateHeading">
            <Translate contentKey="comexApp.bursaAPIBidCert.home.createOrEditLabel">Create or edit a BursaAPIBidCert</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bursa-api-bid-cert-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.endpointURL')}
                id="bursa-api-bid-cert-endpointURL"
                name="endpointURL"
                data-cy="endpointURL"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.ecertNo')}
                id="bursa-api-bid-cert-ecertNo"
                name="ecertNo"
                data-cy="ecertNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.memberShortName')}
                id="bursa-api-bid-cert-memberShortName"
                name="memberShortName"
                data-cy="memberShortName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 8, message: translate('entity.validation.maxlength', { max: 8 }) },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.successYN')}
                id="bursa-api-bid-cert-successYN"
                name="successYN"
                data-cy="successYN"
                type="text"
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.msg')}
                id="bursa-api-bid-cert-msg"
                name="msg"
                data-cy="msg"
                type="text"
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.buyer')}
                id="bursa-api-bid-cert-buyer"
                name="buyer"
                data-cy="buyer"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.owner')}
                id="bursa-api-bid-cert-owner"
                name="owner"
                data-cy="owner"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.bidNo')}
                id="bursa-api-bid-cert-bidNo"
                name="bidNo"
                data-cy="bidNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.totalValue')}
                id="bursa-api-bid-cert-totalValue"
                name="totalValue"
                data-cy="totalValue"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.currency')}
                id="bursa-api-bid-cert-currency"
                name="currency"
                data-cy="currency"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.price')}
                id="bursa-api-bid-cert-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  min: { value: 0, message: translate('entity.validation.min', { min: 0 }) },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.priceMYR')}
                id="bursa-api-bid-cert-priceMYR"
                name="priceMYR"
                data-cy="priceMYR"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  min: { value: 0, message: translate('entity.validation.min', { min: 0 }) },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.purchaseTimeDate')}
                id="bursa-api-bid-cert-purchaseTimeDate"
                name="purchaseTimeDate"
                data-cy="purchaseTimeDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.valueDate')}
                id="bursa-api-bid-cert-valueDate"
                name="valueDate"
                data-cy="valueDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.pName')}
                id="bursa-api-bid-cert-pName"
                name="pName"
                data-cy="pName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.pVolume')}
                id="bursa-api-bid-cert-pVolume"
                name="pVolume"
                data-cy="pVolume"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.supplier')}
                id="bursa-api-bid-cert-supplier"
                name="supplier"
                data-cy="supplier"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIBidCert.volume')}
                id="bursa-api-bid-cert-volume"
                name="volume"
                data-cy="volume"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/bursa-api-bid-cert" replace>
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BursaAPIBidCertUpdate;
